<div class="header-menu">
  <div class="teachers-logo" routerLink="upcoming"></div>
  <div class="header-greeting"><span>Hello {{myUser.user.first_name}}!</span></div>

  <div class="header-buttons">
    <div *ngIf="myUser" class="item teacher-avatar" routerLink="/myaccount">
      <img class="user-avatar" src="{{defaultAvatar}}" *ngIf="myUser.user.photo_profile === null">
      <img class="user-avatar" src="{{myUser.user.photo_profile.thumbnail_150}}"
        *ngIf="myUser.user.photo_profile !== null">
    </div>
    <!--<div class="item help-button" routerLinkActive=" "><a class="faq" href="https://lingueoteachers.crisp.help/fr/" target="_blank">FAQ</a></div>-->
  </div>
</div>

<div class="nav-block">
  @if (myUser && myUser.status !== 'refused') {

  <div class="desktop-navrow nav-upcoming" routerLinkActive="  focused" routerLink="/upcoming" *ngIf="hasDefaultTag">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.upcoming-class</span>
  </div>
  <div class="desktop-navrow nav-lilate" routerLinkActive="  focused"
    *ngIf="myUser.is_lilate_examiner && !hasDefaultTag" routerLink="/lilates">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.lilates</span>
  </div>
  <div class="desktop-navrow nav-schedule" routerLinkActive="  focused" routerLink="/schedule">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.schedule-avaibilities</span>
  </div>
  <div class="desktop-navrow nav-reports" routerLinkActive="  focused" routerLink="/reports" *ngIf="hasDefaultTag">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.class-reports</span>
  </div>
  <div class="desktop-navrow nav-lilate" routerLinkActive="  focused" *ngIf="myUser.is_lilate_examiner && hasDefaultTag"
    routerLink="/lilates">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.lilates</span>
  </div>
  <div class="desktop-navrow nav-lilate" routerLinkActive="  focused" *ngIf="myUser.is_lilate_examiner"
    routerLink="/variants">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.exam-previews</span>
    <div class="unread-counter" *ngIf="unread_examination_variants_count>0">{{ unread_examination_variants_count }}
    </div>
  </div>
  <div class="desktop-navrow nav-trainings" routerLinkActive="  focused" routerLink="/trainings" *ngIf="hasDefaultTag">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.student-trainings</span>
  </div>
  <div class="desktop-navrow nav-messages" routerLinkActive="  focused" routerLink="/messages" *ngIf="hasDefaultTag">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.messages</span>
    <div class="unread-counter" *ngIf="nb_unreadMessages>0">{{ nb_unreadMessages }}</div>
  </div>
  <div class="desktop-navrow nav-sheets" routerLinkActive="  focused"
    *ngIf="checkFeaturePermission('sheets') && checkAvailableLanguageSheets() && hasDefaultTag" routerLink="/sheets">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.sheets</span>
  </div>
  }
  <div class="desktop-navrow nav-billing" routerLinkActive="  focused" routerLink="/billing">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.billing</span>
  </div>
  <div class="desktop-navrow nav-account" routerLinkActive="  focused" routerLink="/myaccount">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.myaccount</span>
  </div>
  <div class="logout-navrow nav-logout" routerLinkActive="  focused" routerLink="/logout" (click)="logout()">
    <span class="sidenav-icon"></span>
    <span class="sidenav-title" translate>teacher.nav.log-out</span>
  </div>
</div>